import { CreditNoteReason } from '@galaxy/billing';

export enum DisplayCreditNoteReason {
  DUPLICATE_CHARGE = 'BILLING.CREDIT_NOTE_PAGE.DUPLICATE_CHARGE',
  PRODUCT_UNSATISFACTORY = 'BILLING.CREDIT_NOTE_PAGE.PRODUCT_UNSATISFACTORY',
  ORDER_CHANGE = 'BILLING.CREDIT_NOTE_PAGE.ORDER_CHANGE',
  OTHER = 'BILLING.CREDIT_NOTE_PAGE.OTHER',
  UNSPECIFIED = '',
}

export function displayReasonToCreditNoteReason(reason: DisplayCreditNoteReason): CreditNoteReason {
  switch (reason) {
    case DisplayCreditNoteReason.DUPLICATE_CHARGE:
      return CreditNoteReason.DUPLICATE_CHARGE;
    case DisplayCreditNoteReason.PRODUCT_UNSATISFACTORY:
      return CreditNoteReason.PRODUCT_UNSATISFACTORY;
    case DisplayCreditNoteReason.ORDER_CHANGE:
      return CreditNoteReason.ORDER_CHANGE;
    case DisplayCreditNoteReason.OTHER:
      return CreditNoteReason.OTHER;
    default:
      return CreditNoteReason.UNSPECIFIED;
  }
}

export function creditNoteReasonToDisplayReason(reason: CreditNoteReason): DisplayCreditNoteReason {
  switch (reason) {
    case CreditNoteReason.DUPLICATE_CHARGE:
      return DisplayCreditNoteReason.DUPLICATE_CHARGE;
    case CreditNoteReason.PRODUCT_UNSATISFACTORY:
      return DisplayCreditNoteReason.PRODUCT_UNSATISFACTORY;
    case CreditNoteReason.ORDER_CHANGE:
      return DisplayCreditNoteReason.ORDER_CHANGE;
    case CreditNoteReason.OTHER:
      return DisplayCreditNoteReason.OTHER;
    default:
      return DisplayCreditNoteReason.UNSPECIFIED;
  }
}
